import { makeStyles } from '@material-ui/styles';

export default makeStyles(() => ({
  field: {
    width: '100%',
  },
}));
